import {$clientApi} from "../http";
import {IPublicTrainer} from "../models/Trainer";

class TrainersServiceClass {

    async getTrainers() {
        return $clientApi.get<IPublicTrainer[]>(`api/public/instructors`)
    }

}

export const TrainersService = new TrainersServiceClass();